import React from "react";
import "./PrayerTime.css";
import namazTime1 from "../../assets/img/namaz-time-icon-1.png";
import namazTime2 from "../../assets/img/namaz-time-icon-2.png";
import namazTime3 from "../../assets/img/namaz-time-icon-3.png";
import namazTime4 from "../../assets/img/namaz-time-icon-4.png";
import namazTime5 from "../../assets/img/namaz-time-icon-5.png";
import namazTime6 from "../../assets/img/namaz-time-icon-6.png";

const PrayerTime = () => {
  return (
    <div className="prayer-container">
      <section className="gap no-top">
        <div className="container">
          <div className="namaz-timing">
            <div className="namaz-time">
              <img src={namazTime1} alt="icon" />
              <h4>Fajr</h4>
              <h5>
                3:24 AM<span>Iqamah:4:15 AM</span>
              </h5>
            </div>
            <div className="namaz-time">
              <img src={namazTime2} alt="icon" />
              <h4>Zuhr</h4>
              <h5>
                01:09 PM<span>Iqamah:1:30 PM</span>
              </h5>
            </div>
            <div className="namaz-time">
              <img src={namazTime3} alt="icon" />
              <h4>Asr</h4>
              <h5>
                6:29 PM<span>Iqamah:7:30 PM</span>
              </h5>
            </div>
            <div className="namaz-time">
              <img src={namazTime4} alt="icon" />
              <h4>Magrib</h4>
              <h5>
                9:01 PM<span>Iqamah:9:01 PM</span>
              </h5>
            </div>
            <div className="namaz-time">
              <img src={namazTime5} alt="icon" />
              <h4>Isha</h4>
              <h5>
                10:10 PM<span>Iqamah:10:45 PM</span>
              </h5>
            </div>
            <div className="namaz-time">
              <img src={namazTime6} alt="icon" />
              <h4>Jummah</h4>
              <h5>
                01:10 PM<span>Iqamah:02:45 PM</span>
              </h5>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrayerTime;
